import { Switch } from "@mui/material";
import DropDownButtons from "components/Ui/DropDownButtons/DropDownButtons";
import TableBodyCells from "components/Ui/TableBodyCells/TableBodyCells";
import { formatDate } from "utils/dateFormat";
// The status pill of the dashboard.
import "components/Ui/AppPresenceBadge/appPresenceBadge.scss";
import {
    OFFER_STATE_PILL,
    describeAreas,
    describeBenefit,
    describeCondition,
    describeFunder,
    describeSchedule,
    describeVendors,
    offerState,
} from "../deliveryOfferModel";

/** The dates of an offer, then its days and its hours when it has some. */
const formatPeriod = (offer) => {
    const dates =
        !offer?.start_date && !offer?.end_date
            ? "دائم"
            : `${formatDate(offer?.start_date) ?? "—"} ← ${formatDate(offer?.end_date) ?? "—"}`;
    const schedule = describeSchedule(offer);

    return schedule ? `${dates} · ${schedule}` : dates;
};

const DeliveryOfferRow = (props) => {
    const { offer } = props;

    const statePill = OFFER_STATE_PILL[offerState(offer, props.today)];
    const vendorNames = (offer?.vendorUsers ?? []).map((vendor) => vendor.name).join("، ");
    const areaNames = (offer?.areas ?? []).map((area) => area.name).join("، ");

    const cellRenderers = {
        id: () => <td>{offer?.id}</td>,
        name: () => (
            <td className="name">
                <h6>{offer?.name}</h6>
            </td>
        ),
        discount: () => <td>{describeBenefit(offer)}</td>,
        condition: () => <td className="cell-wrap">{describeCondition(offer)}</td>,
        fundedBy: () => <td>{describeFunder(offer)}</td>,
        vendors: () => <td title={vendorNames}>{describeVendors(offer)}</td>,
        areas: () => <td title={areaNames}>{describeAreas(offer)}</td>,
        city: () => <td>{offer?.city?.name || "—"}</td>,
        period: () => <td className="cell-wrap">{formatPeriod(offer)}</td>,
        // The switch, and what it means today: an offer with its switch on
        // gives nothing before its first day and after its last day.
        active: () => (
            <td>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <Switch
                        color="warning"
                        size="small"
                        checked={!!offer?.active}
                        onChange={() => props.toggleActive(offer)}
                    />
                    <span className={`app-presence app-presence--${statePill.tone}`}>
                        <span className="app-presence__dot" aria-hidden="true" />
                        {statePill.label}
                    </span>
                </div>
            </td>
        ),
        actions: () => (
            <td>
                <DropDownButtons
                    edit={() => {
                        props.setSelectedOfferValue(offer);
                        props.toggleEditForm();
                    }}
                    delete={() => {
                        props.setSelectedOfferValue(offer);
                        props.toggleDelete();
                    }}
                ></DropDownButtons>
            </td>
        ),
    };

    return (
        <tr className="item">
            <TableBodyCells visibleColumns={props.visibleColumns} renderers={cellRenderers} />
        </tr>
    );
};

export default DeliveryOfferRow;
